<section class="city-list-section">
  <mat-card class="city-picker-card" appearance="outlined">
    <div class="city-picker-header">
      <h2>Select Your City</h2>
      <p>Choose your primary operating city to continue.</p>
    </div>

    <mat-divider></mat-divider>

    <div class="city-scroll-content">
      @if (isLoading) {
      <ion-row class="city-grid">
        @for (item of skeletonList; track $index) {
        <ion-col size="6" size-md="4" class="city-col">
          <div class="city-option city-option-skeleton">
            <ion-skeleton-text class="city-image-wrap" [animated]="true"></ion-skeleton-text>
            <ion-skeleton-text class="city-name-skeleton" [animated]="true"></ion-skeleton-text>
          </div>
        </ion-col>
        }
      </ion-row>
      } @else {
      <ion-row class="city-grid">
        @for (city of cityList; track city.id) {
        <ion-col size="6" size-md="4" class="city-col">
      <button
        class="city-option"
        type="button"
        matRipple
        [ngClass]="{ 'is-selected': selectedCityId === city.id }"
        [attr.aria-pressed]="selectedCityId === city.id"
        [attr.aria-label]="'Select ' + city.name"
        (click)="selectCity(city)"
      >
        <div class="city-image-wrap">
          @if (!city.hasImageError && city.imageUrl) {
          <img [src]="city.imageUrl" [alt]="city.name" loading="lazy" (error)="city.hasImageError = true" />
          } @else {
          <mat-icon class="city-fallback-icon" aria-hidden="true">location_city</mat-icon>
          }
        </div>
        <p>{{ city.name }}</p>
      </button>
        </ion-col>
        }
      </ion-row>
      }
    </div>

    <mat-divider></mat-divider>

    <mat-card-actions align="end" class="city-footer">
      <button mat-stroked-button type="button" class="close-btn" (click)="closeDialog()">
        <mat-icon>close</mat-icon>
        Close
      </button>
    </mat-card-actions>
  </mat-card>
</section>
